import { createAction } from 'typesafe-actions';

import { ThemaName } from './types';

export const selectThemeName = createAction('theme/SELECT_THEME_NAME')<ThemaName>();
export const detectThemeName = createAction('theme/DETECT_THEME_NAME')<void>();
